import { listenDb, offListenDb } from "@/js/firebase";
import { getUrlParam } from "@/js/functions";
import { useLiveStore } from "@/template/live/_store";

import React from "react";

const useQuestion = (lastActiveSessionId: string) => {
  const [activeQuiz, setactiveQuiz] = React.useState({});
  const { setquestionStatus } = useLiveStore();

  React.useEffect(() => {
    if (lastActiveSessionId) {
      // questionStatusのlisten
      listenDb(
        `${getUrlParam(0)}/questionStatus/${getUrlParam(
          1
        )}/${lastActiveSessionId}`,
        (v) => {
          setactiveQuiz(v);
          setquestionStatus(v);
        }
      );

      return () => {
        offListenDb(
          `${getUrlParam(0)}/questionStatus/${getUrlParam(
            1
          )}/${lastActiveSessionId}`
        );
      };
    }
  }, [lastActiveSessionId]);

  return {
    activeQuiz,
  };
};

export default useQuestion;
